import React from 'react';
import { useLocation } from 'react-router-dom';
import { MetricAction, MetricContext, MetricEventSource } from '@src/metrics/metrics.enum';
import { getActiveMetricsContext, trackEvent } from '@src/metrics';
import { NEW_FUNNEL_ROUTE } from '@src/Routes/links';
import { Link } from '@src/components/Link';
import './styles.scss';

export const FreemiumNoticeWrapper = () => {
  const location = useLocation();

  const pathname = location.pathname;

  function onClick() {
    trackEvent({
      context: MetricContext.BANNER,
      interaction: MetricAction.OPEN_ADD_OPENING,
      payload: {
        'Event Source': MetricEventSource.TOP_NOTICE_BAR,
        'Previous Context': getActiveMetricsContext(pathname),
      },
    });
  }

  return (
    !pathname.startsWith('/funnel') && (
      <Link to={NEW_FUNNEL_ROUTE} onClick={onClick}>
        <div className="freemium-notice">
          <span className="freemium-notice__text">
            <strong>Post your job for free. &nbsp;</strong> You can now post a job opening to MeetFrank starting from
            0€.
          </span>

          <span className="freemium-notice__button">Post a job</span>
        </div>
      </Link>
    )
  );
};
